import { LocalStorageService } from './local-storage.service';
import { StringHelper } from '../helpers/strings.helper';
import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { BeneficiaryModel, RecuringTransferRquest, TransferRequestModal } from "../../shared/models/transfer.model";
import { ConfigsModel } from "../../shared/models/configs.model";
import { Subject } from "rxjs";
import { RecurringTransfersTransactionModel, TransactionDetail } from '../../shared/models/transactions-model';
import { DepositConfigModel } from '../../shared/models/deposit.model';

@Injectable()
export class TransferService {
	ACCOUNT_NO_SAVER = 'YBN_VEK_12345M';
	ACCOUNT_NAME_SAVER = 'YBN_VENE_12345L';
	private accountNo = null;
	private accountCustomerName = null;
	private variant: string;
	private transferRequest: TransferRequestModal;
	private goToTransactions = new Subject<any>();
	_goToTransactions$ = this.goToTransactions.asObservable();
	private repeatTransaction = new Subject<TransactionDetail>();
	_repeatTransqaction$ = this.repeatTransaction.asObservable();
	private goToManageBeneficiary = new Subject<any>();
	_goToManageBeneficiary$ = this.goToManageBeneficiary.asObservable();
	private goToStandingOrders = new Subject<any>();
	_goToStandingOrders$ = this.goToStandingOrders.asObservable();

	private editStandingOrderDetail = new Subject<any>();
	_editStandingOrder$ = this.editStandingOrderDetail.asObservable();

	constructor(
		private apiClientHelper: ApiClientHelper,
		private localStorage: LocalStorageService,
		public config: AppConfig,
	) {
		this.setAccountNo(this.localStorage.get(this.ACCOUNT_NO_SAVER), true);
		this.setAccountCustomerName(this.localStorage.get(this.ACCOUNT_NAME_SAVER), true);
	}

	setTransferRequest(transferRequest: TransferRequestModal) {
		this.transferRequest = null;
		this.transferRequest = transferRequest;
	}

	setGoToTransactions() {
		this.goToTransactions.next(true);
	}

	goToManageBeneficiaryEvent() {
		this.goToManageBeneficiary.next(true);
	}

	setRepeatTransaction(data: TransactionDetail) {
		this.repeatTransaction.next(data);
	}

	getTransferRequest() {
		return this.transferRequest;
	}

	goToStandingOrder() {
		this.goToStandingOrders.next(true);
	}

	editStandingOrder(standingOrder) {
		this.editStandingOrderDetail.next(standingOrder);
	}

	setAccountNo(accountNo, initialize?) {
		this.accountNo = accountNo;
		if (!initialize) {
			this.localStorage.save(this.ACCOUNT_NO_SAVER, accountNo);
		}
	}

	setAccountCustomerName(name, initialize?) {
		this.accountCustomerName = name;
		if (!initialize) {
			this.localStorage.save(this.ACCOUNT_NAME_SAVER, name);
		}
	}

	getAccountNo() {
		return this.accountNo;
	}

	getCustomerAccountName() {
		return this.accountCustomerName;
	}

	getConfig(): Promise<ConfigsModel> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/configurations`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBeneficiaries(params: object): Promise<BeneficiaryModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/beneficiary/deposit?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAirtimeBeneficiaries(params: object): Promise<BeneficiaryModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/beneficiary/airtime?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBillPaymentBeneficiaries(params: object): Promise<BeneficiaryModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/beneficiary/bill-payment?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getRecurringTransferLimit() {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/configurations/recurring-transfers`;
		return this.apiClientHelper.getForPromise(url);
	}

	getTransferTransactions(params: object) {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/transactions/deposits/all?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getSingleTransferTransaction(params: object) {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/transactions/deposits/details?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getRecurringTransfers(params: object): Promise<RecurringTransfersTransactionModel> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/orders?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getRecurringTransfersTransactions(params: object): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/transactions?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getRecurringTransfersTransactionTransfer(id: number | string): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/transactions/${id}/deposits`;
		return this.apiClientHelper.getForPromise(url);
	}

	createRecuringTransfer(params: RecuringTransferRquest): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/orders`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	editRecuringTransfer(id: number | string, params: RecuringTransferRquest): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/orders/${id}`;
		return this.apiClientHelper.putForPromise(url, params);
	}

	disableRecuringTransfer(id: number | string, params): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/orders/${id}/disable`;
		return this.apiClientHelper.putForPromise(url, params);
	}

	pauseRecurringTransfers(id: string | number) {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/orders/${id}/pause`;
		return this.apiClientHelper.putForPromise(url, {});
	}

	restartRecurringTransfers(id: string | number) {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/recurring-transfers/orders/${id}/restart`;
		return this.apiClientHelper.putForPromise(url, {});
	}

	transfer(params: object): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/${this.config.USE_LOOM_MFA_SDK ? 'v2' : 'v1'}/wallets/deposit`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	buyAirtime(params: object): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/${this.config.STAFF_USER_AIRTIME_REQUEST ? 'v2' : 'v1'}/wallets/airtime`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	payBills(params: object): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/${this.config.STAFF_USER_BILL_PAYMENT_REQUEST ? 'v2' : 'v1'}/wallets/bill-payment`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	getTransferConfigurations(): Promise<DepositConfigModel> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/configurations/deposit`;
		return this.apiClientHelper.getForPromise(url);
	}

	accountNameEnquiry(params: object) {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/agents/validate/account?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getFeeInquiry(params: object) {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/transactions/deposits/fee?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getWalletSummary() {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/wallets/summary?pageNumber=1&pageSize=10`;
		return this.apiClientHelper.getForPromise(url);
	}

	getWalletBalances() {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/wallets/balances`;
		return this.apiClientHelper.getForPromise(url);
	}

	validateTransfer(payload) {
		const url = this.config.MONIEPOINT_DEPOSIT + (this.config.USE_NEW_TRANSFER_SUMMARY ? '/api/v3/wallets/transfer/summary' : '/api/v1/wallets/transactions/validate-and-fee');
		return this.apiClientHelper.postForPromise(url, payload);
	}

	makeTransferRequest(payload) {
		const url = `${this.config.MONIEPOINT_HOST}/api/v2/wallets/deposit`;
		return this.apiClientHelper.postForPromise(url, payload, false);
	}

	getWalletTransactions(params: object) {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/wallets/transactions?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}


	getBillerCategories(): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/bill-payments/categories`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBillers(params?): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/bill-payments/categories/${params}/billers`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBillerProducts(params): Promise<any> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/bill-payments/biller-products/${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	validateBillCustomer(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/wallets/bill-payment/validate?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPosTransfers(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/pos-transfers?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPosTransfersByStatus(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/pos-transfers-by-status?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPendingPosTransfersSummary(): Promise<any> {
		//const urlString = StringHelper.toUrlString();
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/pending-pos-transfer-summary`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPosTransfersByFilter(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/pos-transfers/filter?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getPosTransferTransactionDetail(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/pos-transfers-transaction-detail?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	approveTransferTransaction(params): Promise<any> {
		const normalizedParams = encodeURIComponent(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/${normalizedParams}/approve-transaction`;
		return this.apiClientHelper.postForPromise(url, null);
	}

	approveTransferTransaction2(params) {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/approve-transaction`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	declineTransferTransaction(params): Promise<any> {
		const normalizedParams = encodeURIComponent(params);
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/protected-transfer/${normalizedParams}/decline-transaction`;
		return this.apiClientHelper.postForPromise(url, null);
	}

	deleteBeneficiary(id): Promise<any> {
		const normalizedParams = encodeURIComponent(id);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/beneficiary/deposit?id=${normalizedParams}`;
		return this.apiClientHelper.delete(url, true);
	}

	addBeneficiary(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/beneficiary/deposit`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	updateDailyTransferLimit(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/business/transaction-limits`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	updateDailyTransferLimitV2(params): Promise<any> {
		const url = this.config.MONIEPOINT_HOST + `/api/v2/business/transaction-limits`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	uploadBulkTransferTemplateRequest(params) {
		const url = this.config.MONIEPOINT_DEPOSIT + `/api/v1/bulk-transfer/file/upload`;
		return this.apiClientHelper.newPostAsFormDataForPromise(url, params);
	}

	getSuccessfulBulkTransferEntries(id, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}/entries?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	deleteBulkTransferEntries(sessionKey, rowIndex): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(sessionKey)}/entries/${encodeURI(rowIndex)}`;
		return this.apiClientHelper.delete(url, true);
	}

	getErrorBulkTransferEntries(id, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}/errors?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBulkTransferSummary(id): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getDuplicateErrorBulkTransferEntries(id, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}/duplicates?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	resolveDuplicateErrorBulkTransferEntries(id, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}/duplicates/resolve?${urlString}`;
		return this.apiClientHelper.postForPromise(url, {});
	}

	deleteDuplicateBulkTransferEntries(sessionKey, rowIndex): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(sessionKey)}/duplicates/${encodeURI(rowIndex)}`;
		return this.apiClientHelper.delete(url, true);
	}

	getFieldErrorBulkTransferEntries(id, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}/field-errors?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	resolveFieldErrorBulkTransferEntries(id, params): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}/errors/resolve`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	deleteFieldErrorBulkTransferEntries(sessionKey, rowIndex): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(sessionKey)}/errors/${encodeURI(rowIndex)}`;
		return this.apiClientHelper.delete(url, true);
	}

	processBulkTransferEntries(id, params): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/file/${encodeURI(id)}/process`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	getBulkTransfers(params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/requests?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBulkTransfersTransactions(bulkId, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/requests/${encodeURI(bulkId)}/transactions?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBulkTransfersRefunds(bulkId, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/refunds/${encodeURI(bulkId)}/transactions?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getSpecificBulkTransfer(id): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/requests/${encodeURI(id)}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getSpecificBulkTransfersTransactions(bulkId, specificTransactionId): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/requests/${encodeURI(bulkId)}/transactions/${encodeURI(specificTransactionId)}`;
		return this.apiClientHelper.getForPromise(url);
	}

	downloadBulkTransfersTransactions(bulkId): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/requests/${bulkId}/export`;
		return this.apiClientHelper.getAsBlobForPromise(url);
	}

	getBulkTransfersApprovalDetail(bulkId, ): Promise<any> {
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/approvals/${encodeURI(bulkId)}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getBulkTransfersApprovalBeneficiary(bulkId, params): Promise<any> {
		const urlString = StringHelper.toUrlString(params);
		const url = `${this.config.MONIEPOINT_DEPOSIT}/api/v1/bulk-transfer/approvals/${encodeURI(bulkId)}/beneficiaries?${urlString}`;
		return this.apiClientHelper.getForPromise(url);
	}

}
